const PageLoader = () => {

    return (
        <>
            <div className="container-fluid vh-100 color-main-bg p-3">
                <div className="p-2 d-flex align-items-center justify-content-center flex-column loader-height">
                    <div className="d-flex align-items-center">
                        <div className="loading-dots">
                            <span className="fw-semibold">Loading &nbsp;</span>
                            <div className="loading-dots--dot"></div>
                            <div className="loading-dots--dot"></div>
                            <div className="loading-dots--dot"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageLoader